"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidationPolicyCache = void 0;
var InvalidationPolicyCache_1 = require("./InvalidationPolicyCache");
Object.defineProperty(exports, "InvalidationPolicyCache", { enumerable: true, get: function () { return __importDefault(InvalidationPolicyCache_1).default; } });
//# sourceMappingURL=index.js.map